import { FunnelCompany } from "@/backend/commands/funnel/types"
import { trackFunnelCompanyConversion } from "@/integrations/tracking/gtm"
import { Locale } from "@/lib/i18n"
import axios from "axios"

type FunnelCompanyClientInput = Omit<FunnelCompany, "locale"> & {
  type: "company"
  locale: Locale
}

export const invokeFunnelCompany = async (input: FunnelCompanyClientInput) => {
  try {
    await axios.post("/api/pushFunnelCompany", input)
    trackFunnelCompanyConversion({
      locale: input.locale,
      company: input.company,
      role: input.role,
      stepsCompleted: input.steps.length,
    })
    return true
  } catch {
    return false
  }
}
